<template>
  <v-alert
    :outlined="outlined"
    :dense="dense"
    :dismissible="dismissible"
    :icon="resolvedIcon"
    :close-label="closeLabel"
    class="app-alert"
    :class="[
      alertClass,
      {
        'app-alert--clickable': clickable,
      },
    ]"
    @click="handleClick"
    @input="$emit('input', $event)"
  >
    <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 8px 16px">
      <div>
        <div v-if="title" class="app-alert__title">
          {{ title }}
        </div>

        <div class="app-alert__content">
          <slot />
        </div>
      </div>

      <slot name="actions" />
    </div>
  </v-alert>
</template>

<script>
const variants = {
  primary: {
    icon: 'mdi-information-outline',
  },
  success: {
    icon: 'mdi-check-circle-outline',
  },
  warning: {
    icon: 'mdi-alert-outline',
  },
  error: {
    icon: 'mdi-alert-circle-outline',
  },
  info: {
    icon: 'mdi-information-outline',
  },
}

export default {
  name: 'AppAlert',

  props: {
    type: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      default: '',
    },
    outlined: Boolean,
    dense: Boolean,
    dismissible: Boolean,
    clickable: Boolean,
    closeLabel: {
      type: String,
      default: 'Fechar',
    },
    icon: {
      type: String,
      default: null,
    },
  },

  computed: {
    variant() {
      return variants[this.type] || variants.info
    },

    resolvedIcon() {
      return this.icon || this.variant.icon
    },

    alertClass() {
      return `app-alert--${this.type}`
    },
  },

  methods: {
    handleClick(event) {
      if (!this.clickable) return

      this.$emit('click', event)
    },
  },
}
</script>

<style scoped>
.app-alert {
  background: white !important;
  border-radius: 10px;
}

.app-alert--clickable {
  cursor: pointer;
}

.app-alert__title {
  font-weight: 700;
  margin-bottom: 4px;
}

.app-alert__content {
  font-size: 16px;
}

.app-alert--warning {
  border: 1px solid var(--v-warning-base) !important;
  color: var(--v-warning-base) !important;
}

.app-alert--warning ::v-deep .v-alert__icon,
.app-alert--warning ::v-deep .v-icon {
  color: var(--v-warning-base) !important;
}

.app-alert--success {
  border: 1px solid var(--v-success-base) !important;
  color: var(--v-success-base) !important;
}

.app-alert--success ::v-deep .v-alert__icon,
.app-alert--success ::v-deep .v-icon {
  color: var(--v-success-base) !important;
}

.app-alert--error {
  border: 1px solid var(--v-error-base) !important;
  color: var(--v-error-base) !important;
}

.app-alert--error ::v-deep .v-alert__icon,
.app-alert--error ::v-deep .v-icon {
  color: var(--v-error-base) !important;
}

.app-alert--primary {
  border: 1px solid var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
}

.app-alert--primary ::v-deep .v-alert__icon,
.app-alert--primary ::v-deep .v-icon {
  color: var(--v-primary-base) !important;
}

.app-alert--info {
  border: 1px solid var(--v-info-base) !important;
  color: var(--v-info-base) !important;
}

.app-alert--info ::v-deep .v-alert__icon,
.app-alert--info ::v-deep .v-icon {
  color: var(--v-info-base) !important;
}
</style>
